import { useCallback } from 'react';
import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { DueDiligenceData } from '@Types/OrganizationDueDiligenceData';

export const useGetDueDiligenceDetails = () => {
  const [fetch, response] = useRequest<DueDiligenceData>();

  const getDueDiligenceData = useCallback(
    (organizationId: number) => fetch(API.paths.due_diligence(organizationId), 'get'),
    [fetch],
  );

  return [getDueDiligenceData, response] as const;
};
